module.exports = __webpack_public_path__ + "static/media/school_10.982856b5.png";